/* global swal */

export default function(
  $scope,
  $q,
  $log,
  $stateParams,
  CoursesClass,
  CategoryClass,
  $uibModalInstance,
  $state,
  ApiClass
) {
  'ngInject';
  $scope.cancel = () => $uibModalInstance.dismiss('cancel');
  $scope.profile = $stateParams.employeeID || $scope.profile;

  $scope.addCourse = course => {
    if (course === undefined) {
      $scope.cancel();
      return swal('Error', 'Select a course to add', 'error');
    }

    return ApiClass.coursesIdTypePut(
      { id: course.course_id, type: 'assigned' },
      { profile_uids: [$scope.profile] },
      { queryParams: { manage: true } }
    )
      .then(data => {
        $scope.cancel();
        $state.reload();
      })
      .catch(error => {
        $log.error(error);
      });
  };

  // TODO: needs to manger call
  const promiseArr = [
    ApiClass.coursesGet(
      { courseType: false },
      {},
      {
        queryParams: {
          internal: true,
          filters: JSON.stringify({ deliveryMethods: CoursesClass.delivery_methods, activeOnly: true })
        }
      }
    ),
    CategoryClass.loadCategories()
  ];

  $q.all(promiseArr)
    .then(([{ data }, categories]) => {
      $scope.categoryDict = categories.obj;
      $scope.courses = data.courses;
    })
    .catch($log.error);
}



// WEBPACK FOOTER //
// ./src/app/modals/assignCourse/controller.js